
import { Check } from "lucide-react";

export function Features() {
  const features = [
    {
      title: "Noise Reduction",
      description: "Reduce external noise by up to 80% for a quieter living environment."
    },
    {
      title: "Thermal Insulation",
      description: "Improve energy efficiency and reduce heating bills by up to 65%."
    },
    {
      title: "Heritage Compatible",
      description: "Ideal solutions for listed buildings and conservation areas."
    },
    {
      title: "Enhanced Security",
      description: "Add an extra layer of protection for your property."
    },
    {
      title: "Draught Elimination",
      description: "Stop cold draughts and improve comfort throughout your home."
    },
    {
      title: "Condensation Control",
      description: "Reduce condensation and prevent mold and damp issues."
    }
  ];

  return (
    <section className="py-16 bg-white" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="text-center">
          <h2 id="features-heading" className="text-3xl font-bold text-primary font-montserrat sm:text-4xl">
            Why Choose Secondary Glazing?
          </h2>
          <p className="mt-4 text-xl text-secondary font-inter">
            Enjoy multiple benefits with our professional secondary glazing solutions
          </p>
        </header>

        <ul className="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-3" role="list">
          {features.map((feature, index) => (
            <li 
              key={index} 
              className="bg-gray-50 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <article className="flex items-start">
                <div className="flex-shrink-0" aria-hidden="true">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <Check className="h-6 w-6" />
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-primary font-montserrat">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-secondary font-inter">
                    {feature.description}
                  </p>
                </div>
              </article>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
